
<template>
    <div class="log-view">
      <pre><code>{{log}}</code></pre>
    </div>
</template>

<script>
import PlayerComponent from '../PlayerComponent.vue';

export default {
  extends: PlayerComponent,
  name: 'LogViewLogs',
  props: ['log']
};
</script>

<style lang="scss" scoped>
  @import "../../../style/color_";
  .log-view {
    font-size: 12px;
    line-height: 12px;
    color: $color-secondary;
    scrollbar-width: thin;
  }
</style>
